import { React, PT } from '@gasbuddy/react';
import { Grid, Popup, Button } from 'semantic-ui-react';

export const ConfirmUpdateButton = ({ popupPosition, text, confirm, updater }) => {
  const listItem = (
    <Popup
      trigger={(
        <Button
          basic
          icon="attention"
          data-position={popupPosition}
        >
          {text}
        </Button>
)}
      content={(
        <Grid columns={16} textAlign="center">
          <Grid.Row>
            <Grid.Column width={16}>
              {confirm}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                color="red"
                content="Confirm Update"
                onClick={updater}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
)}
      on="click"
      position={popupPosition}
    />
  );
  return listItem;
};

ConfirmUpdateButton.defaultProps = {
  popupPosition: 'bottom left',
  text: 'Update this item',
  confirm: 'Are you sure?',
};

ConfirmUpdateButton.propTypes = {
  popupPosition: PT.string,
  text: PT.string,
  confirm: PT.string,
  updater: PT.func.isRequired,
};
